import { Checkout } from '@df/checkout/checkout.interfaces';

declare global {
    interface Window {
        Mollie: (profileId: string, settings: NMollie.IMollieSettings) => NMollie.IMollieInstance;
    }
}

export namespace NMollie {
    /**
     * Mollie script url
     */
    export const scriptUrl = 'https://js.mollie.com/v1/mollie.js';

    /**
     * Credit cards method code
     */
    export const cardsMethodCode = 'mollie_methods_creditcard';

    /**
     * Ideal method code
     */
    export const idealMethodCode = 'mollie_methods_ideal';

    /**
     * Cards payment method
     */
    export interface ICardsMethod extends Checkout.IPaymentMethod {
        isTest: boolean;
        config: {
            profile_id: string;
            use_components: boolean;
            vault: boolean;
        };
    }

    /**
     * Ideal payment method
     */
    export interface IIdealMethod extends Checkout.IPaymentMethod {
        isTest: true;
        config: {
            profile_id: 16840687;
            issuersListType: 'radio';
            issuers: IIssuer[];
        };
    }

    export interface IIssuer {
        resource: 'issuer';
        id: string;
        name: string;
        image: {
            size1x: string;
            size2x: string;
            svg: string;
        };
    }

    export interface IMollieInstance {
        createComponent(type: string, options: IComponentOptions): IMollieComponent;
        createToken(): Promise<ICreateTokenResult>;
    }

    export interface IMollieSettings {
        testMode: boolean;
        locale?: string;
    }

    export interface IMollieComponent {
        mount: (id: string | HTMLElement) => void;
        unmount: () => void;
        addEventListener: (type: string, callback: (event: any) => void) => void;
    }

    export interface IComponentOptions {
        styles?: {
            base?: {
                color?: string;
                fontSize?: string;
                '::placeholder'?: {
                    color?: string;
                };
            };
        };
        components?: {
            cardHolder?: {
                label?: string;
            };
            verificationCode?: {
                label?: string;
            };
        };
    }

    export interface ICreateTokenResult {
        error?: { message: string };
        token?: string;
    }
}
